var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "span",
      { staticClass: "text-primary bold" },
      [
        _vm._v(
          "\n    " + _vm._s(_vm._f("fullName")(_vm.clientProfile)) + "\n    "
        ),
        _vm._t("default"),
      ],
      2
    ),
    _vm._v(" "),
    _vm.clientProfile.labelText
      ? _c(
          "span",
          [
            _c(
              "badge",
              {
                staticClass: "ml-1 mb-0",
                style:
                  "background-color: " +
                  _vm.clientProfile.labelColour +
                  " !important",
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.clientProfile.labelText) + "\n    "
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }